<template lang="html">
    <section class="selector-suministro-new row-center" :selected="!!type">
        <div class="contenedor-check" :class="{ 'selected': type === 1 }">
            <input type="radio" id="luz" name="suministro" value="1" v-model="type" @change="emit">
            <label for="luz">{{ $t('contacto.formulario.checkboxes.luz') }} </label>
        </div>
        <div class="contenedor-check" :class="{ 'selected': type === 2 }">
            <input type="radio" id="gas" name="suministro" value="2" v-model="type" @change="emit">
            <label for="gas">{{ $t('contacto.formulario.checkboxes.gas') }} </label>
        </div>
    </section>
</template>

<script lang="js">
import router from '@/router';

export default {
    name: 'selector-suministro',
    props: ['init'],
    mounted() {
        this.type = this.init || 1;
    },
    data() {
        return {
            type: 1
        }
    },
    methods: {
        emit() {
            this.$emit('input', this.type);
            router.replace({
                name: 'inergizate',
                query: {
                    suministro: this.type == 1 ? 'luz' : 'gas'
                }
            })
        },
    }
}
</script>

<style scoped lang="scss">
.selector-suministro-new {
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    align-items: center;
    width: 100%;
    max-width: 100%;
    padding: 10px 0;
    width: 100%;
}

.contenedor-check {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: white;
    border: 2px solid #D1D5DB;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    justify-content: center;
    width: fit-content;
    margin-right: 5px;

    &:hover {
        border-color: #9CA3AF;
    }

    input[type="radio"] {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    label {
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        color: #343A40;
        margin: 0;
        user-select: none;
        display: flex;
        align-items: center;
        padding-bottom: 0;
    }

    // Radio button personalizado
    label::before {
        content: '';
        display: inline-block;
        width: 18px;
        height: 18px;
        border: 2px solid #D1D5DB;
        border-radius: 50%;
        background: white;
        transition: all 0.3s ease;
    }

    // Estado seleccionado
    input[type="radio"]:checked+label::before {
        border-color: #343A40;
        background: #343A40;
        box-shadow: 0 0 0 3px white inset;
    }

    // Contenedor seleccionado
    input[type="radio"]:checked~label {
        color: white;
    }

    // Estilo del contenedor cuando está seleccionado
    &:has(input[type="radio"]:checked) {
        background: #F7A823;
        border-color: #F7A823;
    }

    // Fallback para navegadores que no soportan :has()
    &.selected {
        background: #F7A823;
        border-color: #F7A823;

        label {
            color: white;
        }

        label::before {
            border-color: #343A40;
            background: #343A40;
            box-shadow: 0 0 0 3px white inset;
        }
    }
}

// Responsive para móviles
@media (max-width: 768px) {
    .selector-suministro-new {
        gap: 8px;
        padding: 8px;
    }

    .contenedor-check {
        padding: 10px 12px;
        min-width: 100px;
        font-size: 12px;

        label {
            font-size: 12px;
        }

        label::before {
            width: 16px;
            height: 16px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/parts/selector-suministro.vue